// extracted by mini-css-extract-plugin
export default {"productName":"ProductName_productName__lQ+Gb","whiteLabeled":"ProductName_whiteLabeled__pUbef"};